export default {
    bind(el, binding) {
        el.event = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                if (typeof binding.value === 'function') binding.value(event)
            }
        }
        document.body.addEventListener('click', el.event)
    },
    unbind(el) {
        document.body.removeEventListener('click', el.event)
    },
}
